import React, { useEffect, useState } from "react";
import { Card, Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import SimpleField from "./SimpleField";
import { useLocation } from 'react-router-dom';

const ContactTemplate = ({
    setContact,
    sender = true,
    rememberAddress = false,
    setRememberAddress = () => { }
}) => {
    const { state } = useLocation();

    const [companyName, setCompanyName] = useState("");
    const [name, setName] = useState("");
    const [streetno, setStreetno] = useState("");
    const [areaCode, setAreaCode] = useState("");
    const [town, setTown] = useState("");
    const [country, setCountry] = useState("");
    const [telephoneCode, setTelephoneCode] = useState("");
    const [telephone, setTelephone] = useState("");
    const [VATNO, setVATNO] = useState("");
    const [customsNO, setCustomsNO] = useState("");
    const [email, setEmail] = useState("");

    useEffect(() => {
        let local;
        if (sender) {
            local = window.localStorage.getItem("contactAddress");
            setCountry(state.countryFrom);
        } else {
            local = window.sessionStorage.getItem("recipientAddress");
            setCountry(state.countryTo);
        }
        if (local) {
            const parsedLocal = JSON.parse(local);
            setCompanyName(parsedLocal.companyName || "");
            setName(parsedLocal.name || "");
            setStreetno(parsedLocal.streetno || "");
            setAreaCode(parsedLocal.areaCode || "");
            setTown(parsedLocal.town || "");
            setTelephone(parsedLocal.telephone || "");
            setTelephoneCode(parsedLocal.telephoneCode || "");
            setVATNO(parsedLocal.VATNO || "");
            setCustomsNO(parsedLocal.customsNO || "");
            setEmail(parsedLocal.email || "");
        }
    }, []);

    useEffect(() => {
        setContact({
            companyName,
            name,
            streetno,
            areaCode,
            town,
            country,
            telephone,
            telephoneCode,
            email,
            VATNO,
            customsNO
        });
    }, [
        companyName,
        name,
        streetno,
        areaCode,
        town,
        country,
        telephone,
        telephoneCode,
        email,
        VATNO,
        customsNO,
        setContact
    ]);

    return (
        <Card>
            <Card.Body>
                <Form>
                    <SimpleField
                        name={"Bedrijfsnaam"}
                        value={companyName}
                        setValue={setCompanyName}
                    />
                    <SimpleField
                        name={"Voor- en achternaam"}
                        value={name}
                        setValue={setName}
                    />
                    <SimpleField
                        name={"Straat en huisnummer"}
                        value={streetno}
                        setValue={setStreetno}
                    />
                    <SimpleField
                        name={"Postcode / area code"}
                        value={areaCode}
                        setValue={setAreaCode}
                    />
                    <SimpleField
                        name={"Stad"}
                        value={town}
                        setValue={setTown}
                    />
                    <SimpleField
                        name={"Landcode (tweeletterig)"}
                        value={country}
                        setValue={setCountry}
                        disabled
                    />
                    <Form.Group>
                        <Form.Label>Telefoonnummer</Form.Label>
                        <Container fluid="xs">
                            <Row>
                                <Col xs={4} sm={3} lg={2}>
                                    <InputGroup>
                                        <InputGroup.Text>+</InputGroup.Text>
                                        <Form.Control
                                            type="number"
                                            placeholder="Landnummer"
                                            value={telephoneCode}
                                            onChange={(e) => setTelephoneCode(e.currentTarget.value)}
                                            min="0"
                                            max="9999"
                                        />
                                    </InputGroup>
                                </Col>
                                <Col>
                                    <Form.Control type="text"
                                        value={telephone}
                                        onChange={(e) => setTelephone(e.currentTarget.value)} />
                                </Col>
                            </Row>
                        </Container>
                    </Form.Group>
                    <SimpleField
                        name={"Emailadres"}
                        value={email}
                        setValue={setEmail}
                    />
                    <SimpleField
                        name={"BTW nummer (VAT No.)"}
                        value={VATNO}
                        setValue={setVATNO}
                    />
                    <SimpleField
                        name={"Douane nummer (Customs No. / EORI No.)"}
                        value={customsNO}
                        setValue={setCustomsNO}
                    />
                    {sender && (
                        <Form.Group className="mt-2">
                            <Form.Check
                                label="Onthoud mijn gegevens"
                                onChange={(e) =>
                                    setRememberAddress(e.currentTarget.checked)
                                }
                                checked={rememberAddress}
                            />
                        </Form.Group>
                    )}
                </Form>
            </Card.Body>
        </Card>
    );
};

export default ContactTemplate;
